// extracted by mini-css-extract-plugin
export default {"strokeButton":"StrokeButton_strokeButton__dgq7b","disabled":"StrokeButton_disabled__3ITbo"};